<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title>Signing</mat-card-title>
  </mat-card-header>
  <mat-card-content class="mat-card-content-lg no-bottom-padding">
    <ifc-horizontal-list [items]="listData">
      <ng-template horizontalListCustomTemplate="switchSignatureMethodActionItem">
        <div class="actions">
          <div class="action"
               *ngFor="let option of switchOptions; trackBy: trackBySwitchTarget">
            <a class="action__text"
               (click)="switchMethod.emit(option.target)">{{ option.label }}</a>
            <button mat-icon-button
                    [matTooltip]="option.label"
                    class="action__button"
                    (click)="switchMethod.emit(option.target)">
              <mat-icon class="action__icon">send</mat-icon>
            </button>
          </div>
        </div>
      </ng-template>
      <ng-template horizontalListCustomTemplate="signedAgreementActionItem">
        <div class="action">
          <a class="action__text"
             (click)="downloadSignedAgreement()">Signed agreement</a>
          <button mat-icon-button
                  matTooltip="Download signed agreement"
                  class="action__button"
                  (click)="downloadSignedAgreement()">
            <mat-icon class="action__icon">get_app</mat-icon>
          </button>
        </div>
      </ng-template>
      <ng-template horizontalListCustomTemplate="certificateActionItem">
        <div class="action">
          <a class="action__text"
             (click)="downloadCertificate()">Certificate of Completion</a>
          <button mat-icon-button
                  matTooltip="Download Certificate of Completion"
                  class="action__button"
                  (click)="downloadCertificate()">
            <mat-icon class="action__icon">get_app</mat-icon>
          </button>
        </div>
      </ng-template>
      <ng-template horizontalListCustomTemplate="docuSignEnvelopeActionItem">
        <div class="action">
          <a class="action__text"
             [href]="envelope?.docuSignEnvelopeUrl"
             target="_blank"
             rel="noopener">Open in DocuSign</a>
          <a mat-icon-button
             matTooltip="Open the envelope in DocuSign"
             class="action__button"
             [href]="envelope?.docuSignEnvelopeUrl"
             target="_blank"
             rel="noopener">
            <mat-icon class="action__icon">open_in_new</mat-icon>
          </a>
        </div>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
